// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
$(document).on('ready', function() {

    var showQuickView = function() {
        $("#QuickView .loading").removeClass("shown");
        var contentHeight = $("#QuickView .product-page").innerHeight();
        $("#QuickView .content").css("height", contentHeight + "px");

        setTimeout(function() {
            $("#QuickView .content").addClass("shown");
        }, 350);
    };

    $("html").on(".quick-view-product .main-images-slick img:first", "load", function() {
        showQuickView();
    });

    $("html").on("click", ".quick-view", function(e) {
        e.preventDefault();
        var url = $(this).data("view");

        $("#QuickView .content").removeClass("shown").empty().css("height", 0);
        $("#QuickView").addClass("shown");
        $("#QuickView .loading").addClass("shown");
        $("html, body").addClass("no-scroll");

        $.ajax({
            method: "GET",
            url: url,
            dataType: "html",
            success: function(data) {

                $("#QuickView .content").html(data);
                new theme.Product(document.querySelector('.quick-view-product'));
                // $(".main-images-slick").slick("setPosition");
                // new theme.Product(".quick-view-product");

                setTimeout(function() {
                    showQuickView();
                }, 500);
                var i = 0;
                var interval = setInterval(function() {
                    if (i++ > 10) clearInterval(interval);
                    var contentHeight = $("#QuickView .product-page").innerHeight();
                    $("#QuickView .content").css("height", contentHeight + "px");
                }, 100);



            }
        });


    });

    $("html").on("click", ".full-details", function(e) {
        e.stopPropagation();
        window.location = $(this).attr("href");
    });

    var closeOverlay = function() {
        $("#QuickView").removeClass("shown");
        $("html, body").removeClass("no-scroll");
        setTimeout(function() {
            $("#QuickView .content").empty();
        }, 350);
    };

    $("html").on("click", ".close-overlay", function(e) {
        e.preventDefault();
        closeOverlay();
    });

    $("html").on("click", ".quick-view-add-cart", function(e) {
        closeOverlay();
    });

    $("#QuickView").click(function(e) {
        if (!$(e.target).closest('#QuickView .inner').length) {
            e.preventDefault();
            closeOverlay();
        }
    });


    $("#QuickView").on("click", ".product-single__thumbnail", function(evt) {

        var mainImg = $('.product-single__photo--flex-wrapper:not(.hide)');
        evt.preventDefault();
        var newImageId = $(this).attr('data-image-id');
        var $newImage = $(
            '.product-single__photo--flex-wrapper[data-image-id="' + newImageId + '"]'
        );

        mainImg.addClass('hide');

        $newImage.removeClass("hide");

        $('.active-thumb').removeClass('active-thumb');
        $(this).addClass('active-thumb');

    });

});
